import { get } from "../../service/api";

const GetPaymentMethods = async () => {
    try {
        const response = await get(`/reference/paymentMethod`);
        return response.data;
    } catch (error) {
        console.error('Error GetPaymentMethods:', error);
        throw error;
    }
};

export default GetPaymentMethods;